export const TRANSLATIONS_SK = {
	Logo_Title_Label: "Private Channel Solution - soukromý rozhovor",
	Service_Assist_Label: "Servisní asistent",
	Start_New_LabelBtn: "Nový rozhovor",
	Start_New_Question: "Jak byste chtěli spustit novou soukromou komunikaci?",
	Sms_label: "SMS",
	Email_label: "E-mail",
	Ticket_Id_Label: "ID/ číslo tiketu",
	Code_label: "Kód",
	Channel_List: "Seznam komunikačních způsobů",
	Chat_Label: "Povídat si",
	Call_Label: "Volání",
	Video_Label: "Video",
	Share_Label: "Sdílení",
	Stop_Channel_Label: "Ukončit komunikaci",
	Contact_Details_Label: "Kontaktní údaje",
	Request_Details_Label: "Požadovat detaily",
	Attendees_Label: "Účastníci",
	Customer_Label: "Zákazník",
	Bosch_Expert_Label: "Expert Bosch",
	Type_Your_Message_Label: "Napište svou zprávu",
	Stop_Channel_Question: "Chcete ukončit komunikaci?",
	Yes_Label: "Ano",
	Cancel_Label: "Zrušení",
	Start_New_Video_Session: "Zahájit novou video komunikaci",
	Without_SMS_Label: "Bez SMS",
	Send_SMS_Label: "Pošli SMS",
	Send_Invite_Label: "Poslat pozvánku",
	Log_Out_Question: "Chcete se odhlásit?",
	Welcome_Label: "Vítejte v Soukromém rozhovoru",
	Login_Label: "Přihlásit se",
	Login_Is_Required_Label: "Ke spuštění komunikace je nutné přihlášení",
	Account_Permission_Label: "Tento účet nemá oprávnění ke spuštění komunikace",
	Start_Label: "Start",
	Noted_Recommend: "Kvůli zásadám společnosti Bosch pro používání Firefoxu vám doporučujeme použít jiný prohlížeč, abyste získali co nejlepší uživatelský zážitek z aplikace Private Channel Solution. Doporučené prohlížeče: Microsoft Edge a Google Chrome",
	Available_Languages_Label: "Dostupné jazyky",
	Can_Not_Create_Meeting_Title: "Nelze vytvořit novou soukromou komunikaci",
	Can_Not_Create_Meeting_Content: "Stále jste v aktivní soukromé komunikaci. Před zahájením nové komunikace ukončete aktuální komunikaci.",
	Leave_meeting_Warning: "Opusťte soukromou komunikaci nebo můžete komunikaci ukončit pro všechny. Jakmile komunikace skončí, nelze ji znovu otevřít.",
	Leave_Lable: "Odejít",
	End_Lable: "Konec",
	Meeting_Ended: "Schůzka byla ukončena",
	Start_Channel_Session: "Spusťte komunikaci",
	Start_Channel_Session_Content: "Technik momentálně řeší jiný tiket:",
	Join_Lable: "Připojit",
	Join_Meeting_Label: "Připojte se ke komunikaci",
	Meeting_Information_Label: "Informace o komunikačním kanálu",
	Meeting_ID_Label: "ID komunikace",
	Translate_Option_Title: "Možnost překladu",
	Translate_Mode_Label: "Režim překladu:",
	From_Label: "Z:",
	To_Label: "Na:",
	Chat_Room_Label: "Soukromá komunikace",
	Visual_Connect_Label: "Vizuální připojení",
	Bosch_ID_Label: "Bosch ID",
	Invite_To_Chat_Question: "Jak chcete sdílet pozvánku do soukromé komunikace?",
	Invite_To_Visual_Question: "Jak chcete sdílet pozvánku Visual Connect?",
	Invite_Sms_Question: "Pošlete pozvánku SMS",
	Invite_To_Chat_By_Ticket_ID: "Odeslat pozvánku pomocí ID tiketu",
	Invite_Email_Question: "Odeslat pozvánku e-mailem",
	Link_label: "Odkaz",
	WSA_label: "Workshop Service Assist - asistent autoservisu",
	WSA_Applications_label: "Aplikace",
	WSA_Remote_Diagnostics_label: "Vzdálená diagnostika",
	WSA_Service_Training_label: "Servisní školení",
	WSA_Enter_website_label: "Zadejte webovou stránku",
	WSA_Slogan_label: "Stvořeno pro život",
	WSA_contact_info_label: "Obecné kontaktní údaje",
	WSA_PSIRT_label: "Zabezpečení produktu (PSIRT)",
	WSA_licences_label: "Inovace, patenty a licence",
	WSA_purchasing_label: "Nákup a logistika",
	WSA_copyright_label: "© Robert Bosch GmbH, všechna práva vyhrazena",
	WSA_copyright_information_label: "Informace o společnosti",
	WSA_copyright_notice_label: "Zákonné oznámení",
	WSA_copyright_protectionnotice_label: "Upozornění na ochranu údajů",
	WSA_copyright_terms_label: "Všeobecné obchodní podmínky",
	WSA_copyright_settings_label: "Nastavení ochrany osobních údajů",
	Infor_CorporateInformation_Description: "Zodpovědný za internetové stránky Robert Bosch GmbH",
	Infor_DataProtectionNotice_Description: "Upozornění za ochranu dat pro službu Bosch Remote Diagnostics Service (Vzdálená diagnostika Bosch)",
	Infor_LegalNotice_Description: "Pro uživatele internetových stránek Robert Bosch GmbH",
	Id_panel: "ID",
	Topic_panel: "Téma",
	Make_panel: "Značka",
	Model_pane: "Model",
	Engine_code_panel: "Kód motoru",
	Year_panel: "Rok",
	Vin_panel: "VIN",
	Plate_panel: "SPZ",
	Hardware_panel: "Hardware",
	ar_mode_warning: "Vaše zařízení není pro AR dostupné",
	Write_something: "Napište něco, abychom mohli začít komunikaci",
	Session_title: "Setkání",
	Live_Translation: "Živý překlad",
	Enabled_panel: "Povoleno",
	Joined_note: "Připojili jste se k relaci…",
	Today_panel: "Dnes",
	Read_panel: "Číst",
	Sent_panel: "Odesláno",
	Dis_translation: "Zakázat překlad",
	En_translation: "Povolit překlad",
	Terminated_Channel_note: "Bosch Expert ukončil komunikaci",
	Not_start_note: "ještě nezačalo",
	Retry_note: "Klikněte na „Opakovat“ a zkuste to znovu, nebo zavřete toto okno pro ukončení.",
	Retry_panel: "Zkuste to znovu",
	Thanks_note: "Děkujeme, že využíváte technické služby Bosch. Jsem velmi rádi, že jsme dnes měli příležitost vám pomoci. Pokud opět budete potřebujet pomoci, kontaktujte nás. Přejeme Vám krásný den.",
	Continue_panel: "Povolit živý překlad",
	En_live_translate: "Pokračovat",
	Translate_from: "Přeložit z",
	Translate_to: "Přeložit do",
	Random_ID: "Náhodné ID",
	Anonymous: "Anonymní",
	Generated_ID: "Náhodné ID bylo vygenerováno!",
	Your_ID: "Vaše náhodné ID je:",
	Public_Meeting_ID_Label: "Verejné ID stretnutia:",
	SelectContactPersonModal_Title: "S kým by ste chceli chatovať?",
	SelectContactPersonDropDown_Title: "Kontaktná osoba",
	SelectContactPersonDropDown_Error_Message: "Tento používateľ nemá CIAM ID (používateľský účet pre CDM), vyberte inú kontaktnú osobu na pokračovanie ...",
	TicketCreator__Title: "(tvorca lístka)",
	Wsa_status_title: "Stav WSA",
	Close_panel: "Zatvoriť",
	OCR_Detected_title: "Zistené optické rozpoznávanie znakov:",
	Voice_Call_Label: "Hlasový hovor",
	Invite_To_Voice_Call_Question: "Ako by ste chceli zdieľať pozvánku na hlasový hovor?",
	AR_mode: "Režim AR",
	Switch_modal_title: "Prepnúť",
	Switch_modal_content_Video: "Prepnutie na videohovor úspešné!",
	Switch_modal_content_Voice: "Prepnutie na hlasový hovor úspešné!",
	Video_Call_Label: "Videohovor",
	Functionality_Label: "Funkčnosť",
	Press_Chatting_Button_Label: "Stlačte tlačidlo chatu na spustenie miestnosti na chatovanie",
	WSA_Applications_label_full: "Aplikácie pre servisné dielne",
	WSA_Applications_item_card: "Vstúpiť do aplikácie",
	WSA_Applications_item_card_diagnostic_support: "Diagnostická podpora",
	WSA_Applications_item_card_remote_diagnostics: "Diaľková diagnostika",
	WSA_Applications_item_card_service_training: "Školenie pre služby",
	WSA_Applications_item_card_technical_support: "Technická podpora",
	Header_Label_Settings: "Nastavenia",
	Assistant_Label_Bot: "Asistent",
	Assistant_first_message: "Dobrý deň, ako vám môžem dnes pomôcť?",
	Assistant_today_label: "Dnes",
	Visual_Connect_Pro_btn: "Visual Connect Pro",
	Join_chat_btn: "Pripojiť sa k chatu",
	Your_name_input_label: "Vaše meno",
	Code_input_label: "Kód",
	Start_btn_label: "Poďme na to",
	Change_info_label: "Zmeniť informácie",
	Change_name_label: "Zmeniť meno",
	Change_code_label: "Zmeniť kód",
	assistant_ask_name_message: "Predtým ako začneme, môžem vedieť vaše meno?",
	assistant_ask_code_message: "Prosím, zadajte svoj kód na pripojenie k relácii",
	assistant_ask_change_message: "Prosím, vyberte položku, ktorú chcete zmeniť",
	assistant_ask_change_name_message: "Zadajte svoje meno",
	assistant_ask_change_code_message: "Zadajte kód",
	assistant_ask_change_action_message: "Prosím, vyberte typ akcie",
	assistant__confirm_message: "Prijal som vaše informácie: \n Váš kód: [code] \n Vaše meno: [name] \n Chceli by ste pokračovať?",
	Assistant_Welcome_Bot: "Vitajte v Tessa Bot!",
	End_meeting_Warning: "Ste si istí, že chcete ukončiť stretnutie? Stretnutie už nebude možné použiť po jeho ukončení.",
	Leave_meeting_meesage_Warning: "Chystáte sa ukončiť hovor, kliknite sem na pokračovanie",
	Reject_Switch_modal_content_Voice: "Používateľ neumožňuje zapnúť kameru",
	Change_action_label: "Zmeniť typ akcie",
	BoschExpert_Label_Sender: "Bosch agent",
	Retry_note_v2: "Prosím, zavrite modálne okno a skúste znova alebo zmeňte kód",
	End_Channel_note: "Kanál bol ukončený!",
	Leave_Channel_note: "Technik opustil kanál!",
	Join_Channel_note: "Technik sa pripojil k kanálu!",
	Translation_is_available: "Preklad je k dispozícii!",
	Translation_is_available_detail: "Zistili sme, že váš jazyk je [tech_language] a jazyk odborníkov Bosch je [expert_language]. \n Chceli by ste povoliť živý preklad?",
	No_Label: "Nie",
	Minimize_Label: "Minimalizovať",
	Maximize_Label: "Maximalizovať",
	Close_Session_Label: "Zavrieť reláciu",
	Popup_Title_Warning: "Upozornenie",
	Show_Message_Label: "Kliknite sem pre zobrazenie celej histórie chatu tejto konverzácie",
	Hide_Message_label: "Kliknite sem pre skrytie histórie chatu",
	Close_Channel_Message_Question: "Chcete ukončiť túto reláciu?",
	Channel_noti_joined_message: "[name] sa pripojil k kanálu.",
	Click_to_view_history_message: "Kliknite sem pre zobrazenie histórie chatu",
	Online_Label: "Online",
	Offline_Label: "Offline",
	Onhold_Label: "Čaká sa",
	Busy_Label: "Zaneprázdnený",
	OK_Label: "OK",
	Channel_Notification: "Upozornenie kanálu",
	BE_Leave: "Zdá sa, že Bosch agent bol nejaký čas offline. Môžete pokračovať v čakaní alebo opustiť túto konverzáciu.",
	Chat_LoadingChat_Message: "Načítava sa chat.....",
	Popup_Title_Error: "Ojoj, niečo sa pokazilo!"
};